(function favoriteList() {

    function favoriteList() {
        /**
         * // local object availability
         * @type {favoriteList}
         * @private
         */
        var _this = this;


        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.favorites = _this.util.store('tour-favorites-store');
            _this.render();
            _this.bindEvents();
        };


        /**
         * bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            $('.tour-favorite-list').on('click', '.destroy', this.destroy.bind(this));
            $('.tour-page-add-to-favorite').on('click', function (e) {
                var buttonState =  $(this).attr('button-state');
                if(buttonState === 'ready-to-destroy') {
                    _this.destroy(e);
                } else if (buttonState === 'ready-to-create') {
                    _this.create(e);
                }
                // prevent linking when user clicks on button
                return false;

            });

            $('.tour-list-item-add-to-favorite').on('click', function (e) {
                var buttonState =  $(this).attr('button-state');
                if(buttonState === 'ready-to-destroy') {
                    _this.destroy(e);
                } else if (buttonState === 'ready-to-create') {
                    _this.create(e);
                }
                // prevent linking when user clicks on button
                return false;
            });
            window.addEventListener("storage", _this.message_receive);
        };


        /**
         * message_broadcast
         * @param {String} message
         */
        this.message_broadcast = function  (message) {
            localStorage.setItem('message',JSON.stringify(message));
        };


        /**
         * message_receive
         * @param {Evnet} ev
         */
        this.message_receive = function (ev) {
            var message=JSON.parse(ev.newValue);
            // update favorites variable in App by grabbing data form localStorate
            _this.favorites = _this.util.store('tour-favorites-store');
            _this.render();
        };


        /**
         * util
         * @returns {undefined}
         */
        this.util = {
            uuid: function () {
                /*jshint bitwise:false */
                var i, random;
                var uuid = '';
                for (i = 0; i < 32; i++) {
                    random = Math.random() * 16 | 0;
                    if (i === 8 || i === 12 || i === 16 || i === 20) {
                        uuid += '-';
                    }
                    uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
                }
                return uuid;
            },
            store: function (namespace, data) {
                if (arguments.length > 1) {
                    return localStorage.setItem(namespace, JSON.stringify(data));
                } else {
                    var store = localStorage.getItem(namespace);
                    return (store && JSON.parse(store)) || [];
                }
            }
        };


        /**
         * create
         * @returns {undefined}
         */
        this.create = function (e) {
            var url;
            var title;
            var isTourlistPage = $('.bikealpin-tour-tourlist').length >= 1;
            let isTourlistWithImagePage = $('.bikealpin-tour-tourlistwithimage').length >= 1;
            var isTourDetailPage =  $('.bikealpin-tour-tour').length >= 1;
            if(isTourlistPage || isTourlistWithImagePage) {
                url = window.location.origin + $(e.target).attr('data-item-url');
                title = $(e.target).attr('data-item-title');
            } else if (isTourDetailPage) {
                url = window.location.href;
                title = $(e.target).attr('data-title');
            }
            var urlIsInArray = ( $.grep(_this.favorites, function(obj){
                return obj.url === url;
            }).length >= 1 );
            if(!urlIsInArray) {
                _this.favorites.push({
                    id: _this.util.uuid(),
                    title: title,
                    url:url
                });
                _this.save();
                _this.render();
                _this.message_broadcast('favorite page created!');
            }
            // using "return false" to prevent linking to other page when user clicks on the element
            return false;
        };

        /**
         * save
         * @returns {undefined}
         */
        this.save = function (){
            _this.util.store('tour-favorites-store', _this.favorites);
        };


        /**
         * render
         * @returns {undefined}
         */
        this.render =  function () {
            var ul = $('.tour-favorite-list');
            ul.html('');
            if($(_this.favorites).length >= 1) {
                $('.tour-favorite-list-count').text($(_this.favorites).length);
            } else {
                $('.tour-favorite-list-count').text('');
            }
            $(_this.favorites).each(function (index, item){
                ul.append(
                    $(document.createElement('li'))
                        .attr({
                            'data-id': item.id,
                            'data-url': item.url
                        })
                        .append('<a class="favorite-link" href="' + item.url + '"><i class="fas fa-star"></i>' +  item.title + '</a>')
                        .append('<span class="destroy"><i class="fas fa-trash" aria-hidden="true"></i> </span>')
                );
            });
            _this.updateStarSignInTourPage();
            _this.updateStarSignInTourListPage();
        };


        /**
         * updateStarSignInTourPage
         * @returns {undefined}
         */
        this.updateStarSignInTourPage = function () {
            var currentUrl = window.location.href;
            var foundItem = $.grep(_this.favorites, function(obj){
                if(obj.url === currentUrl) {
                    return obj;
                }
            });

            if(foundItem.length >= 1) {
                $('.tour-page-add-to-favorite').attr({
                    'data-id': foundItem[0].id,
                    'button-state':'ready-to-destroy'
                })
                $('.tour-page-add-to-favorite').find('.fa-star').addClass('fas');
                $('.tour-page-add-to-favorite').find('.fa-star').removeClass('far');
            } else {
                $('.tour-page-add-to-favorite').attr({
                    'data-id': '',
                    'button-state':'ready-to-create'
                })
                $('.tour-page-add-to-favorite').find('.fa-star').addClass('far');
                $('.tour-page-add-to-favorite').find('.fa-star').removeClass('fas');
            }
        };


        /**
         * updateStarSignInTourListPage
         * @returns {undefined}
         */
        this.updateStarSignInTourListPage = function () {
            $('.tour-list-item-add-to-favorite').each(function (index, item){
                var itmeUrl = window.location.origin + $(item).attr('data-item-url');
                var foundItem = $.grep(_this.favorites, function(obj){
                    if(obj.url === itmeUrl) {
                        return obj;
                    }
                });
                if(foundItem.length >=1) {
                    $(item).attr({
                        'data-id': foundItem[0].id,
                        'button-state':'ready-to-destroy'
                    });
                    $(item).find('.fa-star').addClass('fas');
                    $(item).find('.fa-star').removeClass('far');
                } else {
                    $(item).attr({
                        'data-id': '',
                        'button-state':'ready-to-create'
                    });
                    $(item).find('.fa-star').addClass('far');
                    $(item).find('.fa-star').removeClass('fas');
                }
            });
        };


        /**
         * destroy
         * @param {Element} el
         */
        this.destroy = function (e) {
            _this.favorites = _this.util.store('tour-favorites-store');
            if (_this.indexFromEl(e.target) !== undefined) {
                _this.favorites.splice(_this.indexFromEl(e.target), 1);
            }
            _this.save();
            _this.render();
            _this.message_broadcast('favorite list destroyed!');
        };

        /**
         * indexFromEl
         * @param {Element} el
         */
        this.indexFromEl = function (el) {
            var id = $(el).closest('li').data('id') || el.dataset.id;
            var favorites = _this.favorites;
            var i = favorites.length;
            while (i--) {
                if (favorites[i].id === id) {
                    return i;
                }
            }
        };

        /**
         * initialize call
         */
        _this.init();
    }


    // define the global scope
    if (!window.Bikealpin) {
        window.Bikealpin = {};
    }

    window.Bikealpin.favoriteList = favoriteList;
})();


$(document).ready(function () {
    new window.Bikealpin.favoriteList();
});
